import api from './api';

const carpoolService = {
  search: async (params = {}) => {
    const response = await api.get('/covoiturage/carpools', { params });
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/covoiturage/carpools/${id}`);
    return response.data;
  },

  create: async (carpoolData) => {
    const response = await api.post('/covoiturage/carpools', carpoolData, {
      headers: carpoolData instanceof FormData ? { 'Content-Type': 'multipart/form-data' } : {},
    });
    return response.data;
  },

  update: async (id, carpoolData) => {
    const response = await api.put(`/covoiturage/carpools/${id}`, carpoolData);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/covoiturage/carpools/${id}`);
    return response.data;
  },

  getMyCarpools: async () => {
    const response = await api.get('/covoiturage/carpools/my-carpools');
    return response.data;
  },

  createBooking: async (bookingData) => {
    const response = await api.post('/covoiturage/bookings', bookingData);
    return response.data;
  },

  getMyBookings: async () => {
    const response = await api.get('/covoiturage/bookings/my-bookings');
    return response.data;
  },

  cancelBooking: async (id) => {
    const response = await api.put(`/covoiturage/bookings/${id}/cancel`);
    return response.data;
  },
};

export default carpoolService;
